module.exports = __webpack_public_path__ + "img/chart-orange.bef56db5.svg";